// Strict row parsing shared by the bar and lollipop charts, matching the
// PDF template's `parseChartRows` contract exactly so live and downloaded
// reports never disagree on which rows are plotted or what they show.

// Only a JS finite number, or a string that trims down to a clean integer
// or dot-decimal (optional leading "-"), counts as a usable value.
// Everything else - units ("150cm"), thousands separators ("1,200"),
// multiple dots ("42.5.6"), "+"/scientific notation, blank strings,
// null/undefined, booleans, objects/arrays - evaluates to NaN and the row
// is dropped silently.
const CLEAN_NUMBER_STRING = /^-?(?:\d+\.\d+|\d+)$/;

export const parseChartValue = value => {
  if (typeof value === "number") return value;

  if (typeof value === "string") {
    const trimmed = value.trim();
    return CLEAN_NUMBER_STRING.test(trimmed) ? Number(trimmed) : NaN;
  }

  return NaN;
};

// Maps+filters raw payload rows (`item.rows`) into `{ label, legendLabel,
// value, isUser }` points ready for either chart. Rows with a non-finite
// value are dropped entirely - no placeholder bar/dot, no error.
export const parseChartRows = item => {
  const rows = Array.isArray(item?.rows) ? item.rows : [];

  return rows.reduce((points, row) => {
    const value = parseChartValue(row?.value);
    if (!Number.isFinite(value)) return points;

    points.push({
      label: row?.label != null ? String(row.label) : "",
      legendLabel: row?.legend_label != null ? String(row.legend_label) : undefined,
      value,
      // Strict boolean check: truthy strings/numbers ("true", 1) do not count.
      isUser: row?.is_user === true,
    });

    return points;
  }, []);
};

// Display-only formatting for numbers shown on axes/tooltips/lists. Plotted
// data keeps full precision; only what's rendered as text gets rounded.
export const formatChartNumber = value => (Number.isInteger(value) ? String(value) : String(Math.round(value * 100) / 100));
